import FormControl from '@mui/material/FormControl';
import { Select,Box,styled, MenuItem } from '@mui/material';

export const FieldName = styled(Box)`
  margin-bottom: 0.5rem;
  font-weight: 600;
`

const StyledSelect = styled(Select)`
  margin-bottom: 1.5rem;
  height: 2.4rem;
  font-size: 14px;
`;

const Dropdown = ({ type, changeType }) => {
  const names = ['boolean', 'string', 'array'];

  return (
    <FormControl
      size="small"
      sx={{
        width: "120px",
        "& .MuiFormLabel-root": {
          fontSize: "14px",
        },
        "& .MuiOutlinedInput-root": {
          fontSize: "14px",
        },
        "& .MuiListItemText-primary": {
          fontSize: "14px",
          lineHeight: 1,
        },
      }}
    >
   <FieldName>Type</FieldName>
      <StyledSelect
        MenuProps={{
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
        }}
        fullWidth
        value={type.toLowerCase()}
        onChange={(e)=> changeType(e.target.value)}
      >
        <MenuItem value="boolean">boolean</MenuItem>
        <MenuItem value="string">string</MenuItem>
        <MenuItem value="array">array</MenuItem>
      </StyledSelect>
    </FormControl>
  );
};

export default Dropdown;
